@import 'close';

.alert.kdx-cookie {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 999;
	min-height: 107px;
	background-color: #10243F;
	padding-top: 35px;
	padding-bottom: 35px;
	margin: 0;
	width: 100%;

	.container {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		justify-content: center;
		padding-right: var(--bs-gutter-x, 0.75rem);

		.alert-icon {
			margin-right: 16px;

			svg {
				@include svg-format(45px, 45px, $white);
			}
		}

		p {
			margin-top: 0;
			margin-bottom: 0;
			font-family: $font-family-primary;
			color: #FFFFFF;
			@include text-size(16);
			@include line-height(24);
			max-width: 830px;

			a {
				color: #FFFFFF;
			}
		}

		.cookie-links {
			margin-left: auto;

			button.btn.btn-close {
				border-radius: 5px;
				position: static;
				@include text-size(16);
				@include line-height(24);
				background: #FFFFFF;
				color: $primary;
				padding: 11px 24px;
				text-decoration: none;
				opacity: 1;
				width: auto;
				height: auto;
				margin-top: 0;
				font-weight: 500;

				&:hover,
				&:focus {
					color: #FFFFFF;
					background: $primary;
				}
			}
		}
	}

	@include media-breakpoint-down(xl) {

		padding-top: 24px;
		padding-bottom: 24px;

		.container {
			flex-direction: column;

			.alert-icon {
				margin-bottom: 16px;
				margin-right: 0;

				svg {
					@include svg-format(32px, 32px, $white);
				}
			}

			p {
				text-align: center;
			}

			.cookie-links {
				margin-top: 24px;
				width: 100%;

				button.btn.btn-close {
					padding: 11px 0;
					width: 100%;
				}
			}
		}
	}
}